import { MdOutlineClear } from 'react-icons/md'

import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import CreatableSelectInput from '~/components/Inputs/Formik/CreatableSelectInput'
import TextInput from '~/components/Inputs/Formik/TextInput'
import { reactSelectMenuPositionDef } from '~/utils/options'

import './styles.scss'

interface Props {
  index: number
  modalId: string
  onDelete: VoidFunction
  selectOptions: IOption[]
}

const PropertiesField = ({ index, modalId, onDelete, selectOptions }: Props): ReactElement => {
  return (
    <div className="properties-field-component">
      <div className="properties-dropdown">
        <CreatableSelectInput
          {...reactSelectMenuPositionDef(modalId)}
          name={`properties[${index}].key`}
          options={selectOptions}
          placeholder="Name"
        />
        <TextInput name={`properties[${index}].value`} placeholder="Value" />
        <Button ghost onClick={onDelete} type="button">
          <MdOutlineClear color="#626262" size={14} />
        </Button>
      </div>
    </div>
  )
}

export default PropertiesField
